// JSON-LD Structured Data Component for SEO
// Provides rich snippets for search engines

export const generateOrganizationSchema = () => ({
  "@context": "https://schema.org",
  "@type": "Organization",
  "name": "SEG Career Support",
  "url": "https://segcareersupport.com",
  "logo": "https://segcareersupport.com/logo.png",
  "description": "Professional career coaching and workforce development services helping professionals achieve their career goals.",
  "address": {
    "@type": "PostalAddress",
    "streetAddress": "12 Stockbridge Road",
    "addressLocality": "Savannah",
    "addressRegion": "GA",
    "postalCode": "31419",
    "addressCountry": "US"
  },
  "contactPoint": {
    "@type": "ContactPoint",
    "telephone": "+1-912-376-9006",
    "contactType": "customer service",
    "email": "info@segcareersupport.com"
  },
  "sameAs": [
    "https://www.facebook.com/segcareersupport",
    "https://www.linkedin.com/company/segcareersupport"
  ]
});

export const generateLocalBusinessSchema = () => ({
  "@context": "https://schema.org",
  "@type": "ProfessionalService",
  "name": "SEG Career Support",
  "image": "https://segcareersupport.com/logo.png",
  "url": "https://segcareersupport.com",
  "telephone": "+1-912-376-9006",
  "email": "info@segcareersupport.com",
  "address": {
    "@type": "PostalAddress",
    "streetAddress": "12 Stockbridge Road",
    "addressLocality": "Savannah",
    "addressRegion": "GA",
    "postalCode": "31419",
    "addressCountry": "US"
  },
  "priceRange": "$$",
  "openingHoursSpecification": {
    "@type": "OpeningHoursSpecification",
    "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
    "opens": "09:00",
    "closes": "17:00"
  },
  "areaServed": {
    "@type": "Country",
    "name": "United States"
  },
  "serviceType": ["Career Coaching", "Resume Writing", "Interview Preparation", "Job Search Strategy"]
});

export const generateServiceSchema = (service) => ({
  "@context": "https://schema.org",
  "@type": "Service",
  "serviceType": service.title,
  "name": service.title,
  "description": service.short_description || service.description,
  "provider": {
    "@type": "Organization",
    "name": "SEG Career Support",
    "url": "https://segcareersupport.com"
  },
  "areaServed": {
    "@type": "Country",
    "name": "United States"
  }
});

export const generateBlogPostSchema = (post, url) => ({
  "@context": "https://schema.org",
  "@type": "BlogPosting",
  "headline": post.title,
  "description": post.excerpt || post.content?.replace(/<[^>]*>/g, '').substring(0, 160),
  "image": post.featured_image,
  "datePublished": post.created_at,
  "dateModified": post.updated_at || post.created_at,
  "author": {
    "@type": "Person",
    "name": post.author || "SEG Career Support"
  },
  "publisher": {
    "@type": "Organization",
    "name": "SEG Career Support",
    "logo": {
      "@type": "ImageObject",
      "url": "https://segcareersupport.com/logo.png"
    }
  },
  "mainEntityOfPage": {
    "@type": "WebPage",
    "@id": url
  },
  "keywords": post.tags?.join(', ') || 'career, job search, professional development'
});

export const generateBreadcrumbSchema = (items) => ({
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  "itemListElement": items.map((item, index) => ({
    "@type": "ListItem",
    "position": index + 1,
    "name": item.name,
    "item": item.url
  }))
});

export const generateFAQSchema = (faqs) => ({
  "@context": "https://schema.org",
  "@type": "FAQPage",
  "mainEntity": faqs.map(faq => ({
    "@type": "Question",
    "name": faq.question,
    "acceptedAnswer": {
      "@type": "Answer",
      "text": faq.answer
    }
  }))
});

export const generateCourseSchema = (workshop) => ({
  "@context": "https://schema.org",
  "@type": "Course",
  "name": workshop.title,
  "description": workshop.description,
  "provider": {
    "@type": "Organization",
    "name": "SEG Career Support",
    "url": "https://segcareersupport.com"
  }
});

// Component to inject JSON-LD script
const JsonLd = ({ data }) => {
  if (!data) return null;
  
  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(data) }}
    />
  );
};

export default JsonLd;
